import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, EffectFade } from 'swiper/modules'
import '../styles/auth-swiper.scss'
import { useIntl } from 'react-intl'
import brandingConfig from '../../../../../config/brandingConfig'

export default function AuthSwiper() {

  const { formatMessage } = useIntl()

  return (
    <>
      <div
        className='col-md-8 d-flex justify-center align-items-center bgImage h-md-100 text-center order-md-1 order-2 adjuster'
        style={{
          overflowY: 'scroll',
          scrollBehavior: 'smooth',
        }}
      >
        <Swiper
          loop={true}
          spaceBetween={30}
          effect='fade'
          fadeEffect={{ crossFade: true }}
          pagination={{ clickable: true }}
          autoplay={{ delay: 7000 }}
          modules={[EffectFade, Pagination, Autoplay]}
        >
          {/* <SwiperSlide className='d-flex justify-content-center text-center'>
            <div className='d-flex flex-column justify-content-center'>
              <h1 className='text-light fs-1 m-auto fw-bold mb-4 header'>
                {formatMessage({ id: 'Streamline Your process' })}
              </h1>
              <p className='text-light fs-5 w-75 m-auto mb-6 desc'>
                {formatMessage({ id: ' Simplify investor management, maximize your reach, and accelerate your success' })}
              </p>
              <div style={{ justifyContent: 'center !important' }}>
                <img
                  className='imgSize'
                  style={{ margin: 'auto', height: 'auto', width: '60%' }}
                  src={Slide1}
                  alt='slider-img'
                />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className='d-flex justify-content-center text-center'>
            <div className='d-flex flex-column justify-content-center'>
              <h1 className='text-light fs-1 m-auto fw-bold mb-4 header'>
                {formatMessage({ id: 'Massive Investors Database' })}
              </h1>
              <p className='text-light fs-5 w-75 m-auto mb-6 desc'>
                {formatMessage({ id: 'Access 200,000+ investor profiles with contact info, preferences, and history.' })}
              </p>
              <div style={{ justifyContent: 'center !important' }}>
                <img
                  className='imgSize'
                  style={{ margin: 'auto', height: 'auto', width: '60%' }}
                  src={Slide2}
                  alt='slider-img'
                />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className='d-flex justify-content-center text-center'>
            <div className='d-flex flex-column justify-content-center'>
              <h1 className='text-light fs-1 m-auto fw-bold mb-4 header'>{formatMessage({ id: 'Secured Data Rooms' })}</h1>
              <p className='text-light fs-5 w-75 m-auto mb-6 desc'>
                {formatMessage({
                  id: `Share and manage crucial documents securely. Control access rights and track
                document interactions.`})}
              </p>
              <div style={{ justifyContent: 'center !important' }}>
                <img
                  className='imgSize'
                  style={{ margin: 'auto', height: 'auto', width: '60%' }}
                  src={Slide3}
                  alt='slider-img'
                />
              </div>
            </div>
          </SwiperSlide> */}
          {brandingConfig.authPageSliderContent.map((slide, index) => (
            <SwiperSlide key={index} className='d-flex justify-content-center text-center'>
              <div className='d-flex flex-column justify-content-center'>
                <h1 className='text-light fs-1 m-auto fw-bold mb-4 header'>
                  {formatMessage({ id: slide.heading })}
                </h1>
                <p className='text-light fs-5 w-75 m-auto mb-6 desc'>
                  {formatMessage({ id: slide.subHeading })}
                </p>
                <div>
                  <img
                    className='imgSize'
                    style={{ margin: 'auto', height: 'auto', width: '60%' }}
                    src={slide.image || '/default-image.png'}
                    alt={`slider-img-${index}`}
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  )
}
